// extracted by mini-css-extract-plugin
export default {"article":"WhyChooseUs_article__Bbnhw","header":"WhyChooseUs_header__yi6V4"};